export default "__VITE_ASSET__B0mYn6B4__"